import request from '@/utils/request'

/**
 * 查询我的题库
 * @param param
 */
export function fetchLibs() {
	return request.get("/wap/exam/paper/lib/list/my", {})
}

/**
 * 查询练习记录
 * @param param
 */
export function getRecord(id) {
	return request.get(`/wap/exam/paper/practice/record/${id}`, {})
}

/**
 * 查询下一题
 * @param param
 */
export function doNext(id,data) {
	return request.post(`/wap/exam/paper/practice/${id}`, data || {})
}

/**
 * 开始答题
 * @param param
 */
export function doStart(id) {
	return request.post(`/wap/exam/paper/practice/start/${id}`)
}

/**
 * 重新答题
 * @param param
 */
export function doReset(id) {
	return request.post(`/wap/exam/paper/practice/reset/${id}`)
}

/**
 * 答题完成
 * @param param
 */
export function doFinish(id) {
	return request.post(`/wap/exam/paper/practice/finish/${id}`)
}

/**
 * 查询题库试题
 * @param param
 */
export function fetchQuestions(libId) {
	return request.get(`/wap/exam/lib/question/${libId}`, {})
}
/**
 * 查询每日一练
 * @param param
 */
export function fetchDayQuestions(id) {
	return request.get(`/wap/exam/lib/question/day/${id}`, {})
}


/**
 * 每日一练下一题
 * @param param
 */
export function doDayNext(id,data) {
	return request.post(`/wap/exam/paper/practice/day/${id}`, data || {})
}
/**
 * 查询每日一练记录
 * @param param
 */
export function getDayRecord(id) {
	return request.get(`/wap/exam/paper/practice/day/record/${id}`, {})
}

/**
 * 每日一练完成
 * @param param
 */
export function doDayFinish(id) {
	return request.post(`/wap/exam/paper/practice/day/finish/${id}`)
}

/**
 * 绑定套餐
 * @param param
 */
export function bindUser(data) {
	return request.post(`/wap/exam/bind/combo`, data || {})
}

/**
 * 查询我的答题记录
 * @param param
 */
export function getLibDetail(libId) {
	return request.get(`/wap/exam/paper/lib/view/${libId}`)
}
/**
 * 收藏单题
 * @param param
 */
export function doStore(id,queId,star) {
	return request.post(`/wap/exam/lib/question/collect/${id}/${queId}/${star}`)
}
/**
 * 查询我的错题本
 * @param param
 */
export function getLibWrong(id) {
	return request.get(`/wap/exam/lib/question/wrong/${id}`)
}
/**
 * 查询我的收藏
 * @param param
 */
export function getLibStore(id) {
	return request.get(`/wap/exam/lib/question/store/${id}`)
}

